/* eslint-disable no-console */
import React from 'react';
import { TYPES } from 'constants/config';
import { Icon } from 'ui';
import { pluralizeWithCount } from 'utils/string_utils';

export default function CollapsedTitle({
  collapsed,
  totalSteps,
  onClick,
  isExpanded,
  isCertification,
  hasHiddenContents,
}) {
  let lessonCount = 0;
  let pathCount = 0;
  let certCount = 0;

  collapsed.forEach(content => {
    if (content.badge) {
      certCount += 1;
    } else if (
      content.type === TYPES.LESSON ||
      content.type === TYPES.RESOURCE
    ) {
      lessonCount += 1;
    } else {
      pathCount += 1;
    }
  });

  const completedTitle = isCertification
    ? t('paths.dashboard.collapsed.completed_all_certification')
    : t('paths.dashboard.collapsed.completed_all');

  const inProgressTitle = () => {
    const titles = [
      [lessonCount, 'paths.dashboard.collapsed.completed_lesson'],
      [pathCount, 'paths.dashboard.collapsed.completed_path'],
      [certCount, 'paths.dashboard.collapsed.completed_certification'],
    ];

    return titles
      .reduce((acc, [count, key]) => {
        return count ? [...acc, pluralizeWithCount(count, t(key))] : acc;
      }, [])
      .join('; ');
  };

  return (
    <button
      type="button"
      className="u-resetBtn fz-24 ff-ss fw-b w-fill PathContentCollapsed-title"
      onClick={onClick}
    >
      {collapsed.length === totalSteps && !hasHiddenContents ? (
        completedTitle
      ) : (
        <span>{inProgressTitle()}</span>
      )}
      <Icon name={isExpanded ? 'caret_down' : 'caret_right'} className="ml-4" />
    </button>
  );
}
